<template>
  <div class="device-monitor_map">
    <BMap ref="bmap" @loaded="bmapLoaded" />
  </div>
</template>

<script>
import BMapComp from '@/components/bmap';
import { colors, infoContent, patchDeviceMarker, initMarker, setLabel, to } from '@/utils/bmapUtil';
import { mapState } from 'vuex';
import { isDevice } from '@/utils/deviceUtils';

export default {
  name: 'monitorMap',
  components: { BMap: BMapComp },
  data() {
    return {
      labelMap: {},
      markerMap: {},
      bmap: null,
      deviceList: [],
      infoWindow: null,
      mapDict: null
    };
  },
  computed: {
    ...mapState('socket', ['devicesSourseMap', 'deviceIdMap']),
    ...mapState('device', ['monitorMenuActive', 'monitorConfig']),
    filterNoPosDevices() {
      return this.devicesSourseMap.filter(e => e.latitude !== 0 || e.longitude !== 0);
    }
  },
  methods: {
    bmapLoaded(bmap) {
      this.bmap = bmap;

      this.mapDict = {
        B_NORMAL_MAP: window.BMAP_NORMAL_MAP,
        B_SATELLITE_MAP: window.BMAP_HYBRID_MAP
      };

      this.$nextTick(() => {
        const point = new BMap.Point(106.387456, 34.925406);
        this.bmap.centerAndZoom(point, 6);

        this.bmap.setMapType(this.mapDict[this.monitorConfig.mapType]);

        this.bmap.setMinZoom(6);
        this.bmap.setMaxZoom(16);

        initMarker({
          deviceIdMap: this.deviceIdMap,
          source: this.filterNoPosDevices,
          markerMap: this.markerMap,
          bmap: this.bmap,
          clickCallback: e => this.showInfoWindow(e)
        });
        this.monitorMenuActiveChange(this.monitorMenuActive);
      });
    },
    showInfoWindow({ name, state = -1, sn, longitude, latitude, parentId, deviceType }) {
      if (this.infoWindow) {
        this.infoWindow.setContent(
          infoContent({
            name,
            state,
            sn,
            deviceType,
            colors,
            parentId,
            deviceIdMap: this.deviceIdMap,
            router: this.$router
          })
        );

        this.infoWindow.setConfig({ title: deviceType });
      } else {
        this.infoWindow = new BMap.InfoWindow(
          infoContent({
            name,
            state,
            colors,
            sn,
            deviceType,
            parentId,
            deviceIdMap: this.deviceIdMap,
            router: this.$router
          }),
          { offset: new BMap.Size(0, -20), title: deviceType }
        );
      }
      this.bmap.openInfoWindow(this.infoWindow, new BMap.Point(longitude, latitude));
    },
    locateTo({ latitude, longitude, sn, name }) {
      if (!latitude || !longitude) {
        return this.$message.warning(`${name}暂无坐标信息`);
      }

      const coordinate = [longitude, latitude];
      const content = name;
      const labelMap = this.labelMap;

      Object.keys(labelMap).forEach(e => {
        if (e !== sn) {
          this.bmap.removeOverlay(labelMap[e]);
          labelMap[e] = null;
        }
      });

      setLabel({ sn, coordinate, labelMap, content, bmap: this.bmap });
      to(this.bmap, { center: coordinate, zoom: 18 });
    },
    updateMarker(v) {
      v.forEach(e => {
        const { sn, state, longitude, latitude } = e || {};
        if (sn) {
          patchDeviceMarker({
            marker: this.markerMap[sn],
            state: state,
            coordinate: [longitude, latitude]
          });
        }
      });
    },
    monitorMenuActiveChange(n) {
      if (!isDevice(n.nodeType)) return;
      const device = this.deviceIdMap[n.id];

      this.locateTo(device);
    },
    mapTypeChange(n) {
      this.bmap.setMapType(this.mapDict[n]);
    }
  },
  watch: {
    filterNoPosDevices: {
      handler: 'updateMarker',
      deep: true
    },
    monitorMenuActive: {
      handler: 'monitorMenuActiveChange',
      deep: true
    },
    'monitorConfig.mapType': {
      handler: 'mapTypeChange',
      deep: true
    }
  }
};
</script>

<style lang="scss">
.device-monitor_map {
  height: 100%;
}
</style>
